import React, { useRef, useEffect, useState } from "react";

import { useContext } from "react";
import { EnteredContext } from "../context/EnteredContext";

import swingSign from "../spritesheets/swing-sign.png";
import letterSheet from "../spritesheets/letters.png";

export default function Snack(props) {
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);
  const imageRef = useRef(new Image());
  const letterRef = useRef(new Image());

  const [signLoaded, setSignLoaded] = useState(false);
  const letter = {
    A: [0, 0],
    B: [0, 1],
    C: [0, 2],
    D: [0, 3],
    1: [1, 0],
    2: [1, 1],
    3: [1, 2],
    4: [1, 3],
  };

  const { entered, disabled, setDisabled, setSelected } =
    useContext(EnteredContext);

  useEffect(() => {
    let currentFrame = 0;
    let calcW = 0;
    let calcH = -1;
    let width = 68 * 2;
    let height = 68 * 2;

    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext("2d");
    imageRef.current.src = swingSign;

    letterRef.current.src = letterSheet;

    const signLoad = () => {
      if (currentFrame % 8 === 0) {
        calcH = calcH + 1;
      }

      ctxRef.current.clearRect(
        0,
        0,
        canvasRef.current.width,
        canvasRef.current.height,
      ); // Clear the canvas

      ctxRef.current.drawImage(
        imageRef.current, // image of spritesheet
        calcW * width,
        calcH * height, // sx, sy (cut from spritesheet)
        width,
        height, // sw, sh (size of sprite)
        142 * 2, // dx, dy
        34 * 2, // dx, dy (position on canvas)
        width,
        height, // dw, dh (size on canvas)
      );

      currentFrame = currentFrame + 1;
      calcW = (calcW % 8) + 1;
      if (calcW === 8) {
        calcW = 0;
      }

      if (currentFrame < 60) {
        setTimeout(() => {
          requestAnimationFrame(signLoad);
        }, 1000 / 60);
      } else {
        checkLetter();
        setDisabled(false);
      }
    };

    const checkLetter = () => {
      let xLetter = 172 * 2;
      let yLetter = 0;

      if (entered.length === 1) {
        ctxRef.current.drawImage(
          imageRef.current, // image of spritesheet
          3 * width,
          7 * height, // sx, sy (cut from spritesheet)
          width,
          height, // sw, sh (size of sprite)
          142 * 2, // dx, dy
          34 * 2, // dx, dy (position on canvas)
          width,
          height, // dw, dh (size on canvas)
        );

        yLetter = 50 * 2;
      } else if (entered.length === 2) {
        yLetter = 63 * 2;
      } else if (entered.length === 3) {
        yLetter = 76 * 2;
        setSelected(entered);
      }

      ctxRef.current.drawImage(
        letterRef.current, // image of spritesheet
        letter[entered.slice(-1)][0] * 12 * 2,
        letter[entered.slice(-1)][1] * 12 * 2, // sx, sy (cut from spritesheet)
        12 * 2,
        12 * 2, // sw, sh (size of sprite)
        xLetter, // dx, dy
        yLetter, // dx, dy (position on canvas)
        12 * 2,
        12 * 2, // dw, dh (size on canvas)
      );
    };

    if (entered && !signLoaded) {
      setDisabled(true);
      setSignLoaded(true);
      signLoad();
    } else if (entered && !disabled) {
      checkLetter();
    }
  }, [entered]);

  return (
    <div className={props.css}>
      <canvas ref={canvasRef} width={208 * 2} height={248 * 2}></canvas>
    </div>
  );
}
